import { FolderOpenFilled } from '@ant-design/icons'
import { AgentClient } from '~/agents/common/client/agent'
import { Icon } from '~/features/shared/icons'
import { SalesAssistantCommon } from '../common'

export const SalesAssistantAgentClient: AgentClient = {
  key: SalesAssistantCommon.Agent.key,
  getTabs: ({ appSession, pathBase }) => [
    {
      to: `${pathBase}/leads`,
      icon: <Icon name="users" />,
      label: 'Leads',
    },
    {
      to: `${pathBase}/templates`,
      icon: <FolderOpenFilled />,
      label: 'Templates',
    },
    {
      to: `${pathBase}/guidelines`,
      icon: <Icon name="sticky-notes" />,
      label: 'Guidelines',
    },
  ],
}
